<script>

    import { createEventDispatcher } from 'svelte'
    import GoogleMapsMethods from '../$methods/google.maps.methods'

    import SearchBox from '../$components/google.searchbox.svelte'
    import Map from '../$components/google.map.svelte'

    const dispatch = createEventDispatcher()

    export let data = {}

    let marker = null
    let map = null

    async function onLoad(event) {
        map = event.detail

        if(data.placeId || data.address)
            onSelected({detail: data})
    }

    async function onSelected(event) {

        const location = event.detail

        if(!marker)
            marker = GoogleMapsMethods.Marker(map, {draggable: true})

        marker.setPosition(location.coordinates)
        marker.setEvent('dragend', async event => {
            data = {...data, ...marker.location}
            marker.setCenter()
            dispatch('selected')
        })

        marker.setCenter()
        dispatch('selected')
    }

</script>

<div class="columns">
    <div class="column">
        <SearchBox bind:location={data} on:selected={onSelected} showZipcode={false} />
    </div>
</div>
<div class="columns">
    <div class="column">
        <Map on:load={onLoad} height="350px" />
    </div>
</div>